import subscriptionModule from "../subscriptionModule";

function subscriptionCard(premiumService, premiumConstants) {
    "ngInject";

    return {
        restrict: "A",
        templateUrl: premiumConstants.templates.subscriptionCard,
        link: function (scope) {
            scope.layout = {
                priceText: null,
                isSubscribed: false,    //default: plan is not subscribed
                buyButtonEnabled: true, //default: buy button is enabled
                purchaseUrl: "#"        //default: null hyperlink
            };
            initProduct();

            scope.$watch(
                function () {
                    return scope.subscriptionPageData.userPlan;
                },
                function () {
                    updateLayoutByUserPlan();
                }
            );

            scope.buyClick = function (product) {
                //notify the parent controller
                scope.$emit(premiumConstants.events.buyButtonClicked, product);
            }

            function initProduct() {
                scope.layout.priceText = scope.product.price.currency.currencySymbol + scope.product.price.amount;
                if (scope.subscriptionPageData.isInApp) {
                    scope.layout.purchaseUrl = premiumService.getPurchaseUrl(scope.product, premiumConstants.premiumFeatureType.robux);
                }
            }

            function isRecurringSubscription(subscriptionTypeName) {
                var typeName = subscriptionTypeName.toLowerCase();

                //RobloxPremium450 => recurring, RobloxPremium450OneMonth=> not recurring
                return typeName && typeName.indexOf(premiumConstants.premiumFeatureType.month) < 0;
            }

            function updateLayoutByUserPlan() {
                if (scope.subscriptionPageData.userPlan) {
                    scope.layout.buyButtonEnabled = false;
                    scope.layout.isSubscribed = scope.subscriptionPageData.userPlan.premiumFeatureId === scope.product.premiumFeatureId;
                }
            }
        }
    }
}

subscriptionModule
    .directive("subscriptionCard", subscriptionCard);

export default subscriptionCard;